import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class ChangeTime {
  /**
   * 1日分の情報を取得する
   * @param {string} lgCd 市町村コード
   * @param {string} date 日付
   * @param {boolean} sameDay 元の予約日と同じかどうか
   * @param {string} bookingTimearea 元の予約時間
   * @param {number} rsvSetId 予約設定ID
   * @return {Promise<Array>} 1日分の情報
   */
  getDayInfo = async (lgCd, date, sameDay, bookingTimearea, rsvSetId) => {
    const result = await requestManager.post(`${API_PATH}/changetime/r`, {
      lgCd,
      date,
      sameDay,
      bookingTimearea,
      rsvSetId,
    });
    return result.data;
  };
}

export default new ChangeTime();
